import * as Mutations from './mutations';
import { EmailTrackingService } from '../../../common/services/settings/email-tracking.service';
import { PaginationParams } from '../../../common/utils/pagination-params';

export const EmailTrackingModule = {
    state: {
        emailList: [],
        resendEmail: null
    },
    mutations: {
        [Mutations.SET_EMAILS] (state, emailList) {
            state.emailList = emailList;
        },

        [Mutations.RESEND_EMAIL_MODAL_ID] (state, resendEmail) {
            state.resendEmail = resendEmail;
        },
    },
    actions: {
        async getEmails(context) {
            const { data: { content, pageable, totalPages, totalElements, numberOfElements } } =
                await EmailTrackingService.getEmails(context.getters.schoolId,
                    PaginationParams.createParams({
                        size: context.getters.pageSize,
                        page: context.getters.pageNumber,
                        sort: context.getters.sortBy,
                        direction: context.getters.direction,
                        query: context.getters.searchQuery,
                        filters: {
                            ...context.getters.filters
                        }
                    }));
                    context.commit(Mutations.SET_EMAILS, content);
            context.dispatch('configPagination', {
                ...pageable,
                numberOfElements,
                totalElements,
                totalPages,
                callback: () => {
                    return context.dispatch('getEmails');
                }
            });
            context.dispatch('resetSelectedItems');
        },

        async prepareEmail(context,payload) {
            const { emailId, recipientsModal, viewEmailModal } = payload;
            const email = await EmailTrackingService.getEmailById(context.getters.schoolId, emailId);
            context.commit(Mutations.RESEND_EMAIL_MODAL_ID, email.data);
            context.dispatch('openModal', {
                modalName: recipientsModal ? 'MessageRecipientsModal' : (
                    viewEmailModal ? 'EmailTrackingUneditableModal' : 'EmailTrackingBulkModal'
                    ),
                options: {
                    width: '680px',
                },
            });
        },

        resetResendEmail(context) {
            context.commit(Mutations.RESEND_EMAIL_MODAL_ID, null);
        }
    },
    getters: {
        emailList: state => state.emailList,

        resendEmail: state => state.resendEmail,
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/email-tracking/email-tracking.module.js